import React, { Fragment } from 'react';
import clsx from 'clsx';
import IntakeStepStatusIcon from 'assets/svg/IntakeStepStatusIcon';

export type IntakeStepKey = 'hpi' | 'medicalHistory' | 'pharmacy' | 'forms';

export type IntakeStep = {
  key: IntakeStepKey;
  label: string;
  subtext?: string;
  isComplete: boolean;
};

type Props = {
  steps: IntakeStep[];
  currentStep?: IntakeStepKey;
};

function IntakeStepList({ steps, currentStep }: Props) {
  return (
    <div className="mt-6">
      {steps.map((step, index) => {
        const isCurrent = step.key === currentStep;
        return (
          <Fragment key={step.key}>
            <div className="flex items-start gap-3">
              <IntakeStepStatusIcon
                index={index + 1}
                isComplete={step.isComplete}
                isCurrent={isCurrent}
              />
              <div className="pt-1">
                <p className={clsx(
                  'mb-0 text-sm',
                  {
                    'font-semibold text-gray-900': isCurrent,
                    'text-gray-700': !isCurrent,
                  },
                )}
                >
                  {step.label}
                </p>
                {step.subtext && (
                  <p className="mb-0 mt-1 text-xs italic text-[#77889C]">
                    {step.subtext}
                  </p>
                )}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className="my-1.5 ml-[13px] h-7 w-px bg-gradient-to-b from-populate-green/30 to-slate-200" />
            )}
          </Fragment>
        );
      })}
    </div>
  );
}

export default IntakeStepList;
